// src/context/LayoutContext.js
import React, { createContext, useState, useContext, useMemo } from "react";

const LayoutContext = createContext(null);

export const LayoutProvider = ({ children }) => {
  // Default to 'desktop' mode.
  const [layoutMode, setLayoutMode] = useState("desktop");

  const value = useMemo(() => ({ layoutMode, setLayoutMode }), [layoutMode]);

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error("useLayout must be used within a LayoutProvider");
  }
  return context;
};
